<template>
  <div class="slider-component">
    <b-carousel id="carousel-fade" style="text-shadow: 0px 0px 2px #000;" fade indicators img-width="1024" img-height="200" :interval="10000">
      <a v-for="(slider, index) in sliders" :key="index" :href="slider.url" target="_blank">
        <b-carousel-slide :caption="slider.title" :img-src="slider.image" indicator-type="disc">
        </b-carousel-slide>
      </a>
    </b-carousel>
  </div>
</template>

<script>
export default {
  name: "Slider",
  props: {
    sliders: Array
  }
};
</script>

<style lang="sass">
.carousel-caption 
  right: unset
  top: 20%
  max-width: 45%
  text-align: left

  h3
    font-size: 4em
    font-family: "Might Could"
    font-weight: bolder
    color: $dutche-primary-violet

.carousel-item
  height: 30rem

.carousel-indicators
  li
    width: 15px
    height: 15px
    border-radius: 50%
    background-color: transparent
    border: solid 3px #69087d
    opacity: 1
    margin: 0 0.4rem

  .active
    background-color: $dutche-primary-violet


.btn-dutche
  text-transform: uppercase
  border-radius: 0.5rem
  background-color: $dutche-primary-violet
  color: $white
  font-weight: bolder
  padding: 1em 2em
  margin-top: 3rem
</style>

<style>
@media (max-width: 991px) {
  .carousel-caption {
    left: 5%;
    max-width: 55%;
    top: 15%;
  }
  .carousel-caption h3{
    font-size: 3em;
  }
}
</style>

<style>
@media (max-width: 767px) {
  .carousel-item {
    height: auto;
  }
  .carousel-caption {
    left: 10%;
    max-width: 80%;
    top: 5%;
  }
  .carousel-caption h3{
    font-size: 2.25em;
  }
  .btn-dutche {
    padding: .5em 1em;
    min-width: 130px;
  }
  .slider-component img {
    height: 80vh;
    object-fit: cover;
  }
}
</style>

<style>
@media (max-width: 575px) {
  .carousel-caption h3{
    font-size: 2em;
  }
  .btn-dutche {
    font-size: .9rem;
  }
  .carousel-indicators li {
    width: 15px;
    height: 15px;
    border: solid 1px #69087d
  }
}
</style>
